import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
const Login = () =>
  import(/* webpackChunkName: "public-pages" */ "@/components/Login.vue");
const Signup = () =>
  import(/* webpackChunkName: "public-pages" */ "@/components/Signup.vue");
const PrivatePageLayout = () =>
  import(
    /* webpackChunkName: "private-pages" */ "@/components/PrivatePageLayout.vue"
  );
const CookiesPolicy = () =>
  import(
    /* webpackChunkName: "public-pages" */ "@/components/CookiesPolicy.vue"
  );
const Dashboard = () =>
  import(
    /* webpackChunkName: "private-pages" */ "../pages/dashboard/Dashboard.vue"
  );
import ActivateEmail from "../components/ActivateEmail.vue";
import ForgotPassword from "../components/ForgotPassword.vue";
import ResetPassword from "../components/ResetPassword.vue";
import CreateReceiversPage from "../pages/invoiceReceivers/create/CreateReceiverPage.vue";
import EditReceiversPage from "../pages/invoiceReceivers/edit/EditReceiversPage.vue";
import EditInvoicesPage from "../pages/invoices/edit/EditInvoicesPage.vue";
import ViewReceiversPage from "../pages/invoiceReceivers/view/ViewReceiversPage.vue";
import ViewInvoicesPage from "../pages/invoices/view/ViewInvoicesPage.vue";
import ProfilePage from "../pages/profile/ProfilePage.vue";
import ContactPage from "../pages/contact/ContactDashboardPage.vue";

const PublicPageLayout = () =>
  import(
    /* webpackChunkName: "public-pages" */ "@/components/PublicPageLayout.vue"
  );
import CreateInvoicesPage from "../pages/invoices/create/CreateInvoicesPage.vue";
Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    component: PublicPageLayout,
    children: [
      {
        path: "",
        name: "home",
        redirect: '/login'
      },
      {
        path: "signup",
        name: "signup",
        component: Signup,
        meta: {
          title: "signup"
        }
      },
      {
        path: "login",
        name: "login",
        component: Login,
        meta: {
          title: "login"
        }
      },
      {
        path: "/activate",
        name: "activate-email",
        component: ActivateEmail,
        meta: {
          title: "activate-email"
        }
      },
      {
        path: "/reset-password",
        name: "reset-password",
        component: ResetPassword,
        meta: {
          title: "reset-password"
        }
      },
      {
        path: "/forgot-password",
        name: "forgot-password",
        component: ForgotPassword,
        meta: {
          title: "forgot-password"
        }
      },
      {
        path: "/cookies",
        name: "cookies-policy",
        component: CookiesPolicy,
        meta: {
          title: "cookies-policy"
        }
      }
    ]
  },
  {
    path: "/",
    component: PrivatePageLayout,
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: Dashboard,
        meta: {
          title: "dashboard"
        }
      },
      {
        path: "/receivers/create",
        name: "create-receivers-page",
        component: CreateReceiversPage,
        meta: {
          title: "create-receivers-page"
        }
      },
      {
        path: "/receivers/view",
        name: "view-receivers-page",
        component: ViewReceiversPage,
        meta: {
          title: "view-receivers-page"
        }
      },
      {
        path: "/receivers/:id/edit",
        name: "edit-receivers-page",
        component: EditReceiversPage,
        props: route => ({ receiverId: route.params.id }),
        meta: {
          title: "edit-receivers-page"
        }
      },
      {
        path: "/invoices/create",
        name: "create-invoices-page",
        component: CreateInvoicesPage,
        meta: {
          title: "create-invoices-page"
        }
      },
      {
        path: "/invoices/view",
        name: "view-invoices-page",
        component: ViewInvoicesPage,
        meta: {
          title: "view-invoices-page"
        }
      },
      {
        path: "/invoices/:id/edit",
        name: "edit-invoices-page",
        component: EditInvoicesPage,
        props: route => ({ invoiceId: route.params.id }),
        meta: {
          title: "edit-invoices-page"
        }
      },
      {
        path: "/profile",
        name: "profile",
        component: ProfilePage,
        meta: {
          title: "profile"
        }
      },
      {
        path: "/contact",
        name: "contact-dashboard",
        component: ContactPage,
        meta: {
          title: "contact-dashboard"
        }
      }
    ]
  },
  
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  linkActiveClass: 'active',
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

export default router;
